'use client';

import type { Account } from '@repo/api-gw-sdk';
import { createContext, type PropsWithChildren } from 'react';

import { useDAL } from './useDAL';

export const SourceAccountsContext = createContext<{
  sourceAccounts: Account[] | undefined;
  recalculateAccounts: () => void;
} | null>(null);

export const SourceAccountsProvider = ({ children }: PropsWithChildren) => {
  const dal = useDAL();
  const { body: sourceAccountsBody, mutate: mutateAccounts } =
    dal.cloudAccounts.source.list();

  const sourceAccounts = sourceAccountsBody?.accounts
    ?.map((x) => ({
      ...x,
      name: x.name || x.providerAccountId,
    }))
    .sort(
      (a, b) =>
        a.cloudProvider?.localeCompare(b.cloudProvider) ||
        a.name?.localeCompare(b.name)
    );

  return (
    <SourceAccountsContext.Provider
      value={{
        sourceAccounts,
        recalculateAccounts: () => void mutateAccounts(),
      }}
    >
      {children}
    </SourceAccountsContext.Provider>
  );
};
